export const totalEsLocale = {
  'checkout.total.title': 'Total',
  'checkout.total.ivaIncluded': 'I.V.A incluido',
  'checkout.total.tickets': 'Tickets',
  'checkout.total.fees': 'Comisiones',
  'checkout.total.allSalesFinal':
    '*Todas las ventas son finales: no hay reembolsos',

  'checkout.completeBuy': 'Completar compra',

  'checkout.total.promoApplied': 'Se aplicó un descuento de ',
  'checkout.total.promoAppliedWithPercentage':
    'Se aplicó un descuento del {percentage}: ',

  'checkout.total.serviceFee': 'Cargo por boletería',
  'checkout.total.ProcessingFee': 'Comisión de procesamiento',

  'checkout.cancel': 'Modificar tu compra',
} as const;

export const totalEnLocale = {
  'checkout.total.title': 'Total',
  'checkout.total.ivaIncluded': 'Incl. tax',
  'checkout.total.tickets': 'Tickets',
  'checkout.total.fees': 'Fees',
  'checkout.total.allSalesFinal': '*All sales final: no refunds',

  'checkout.completeBuy': 'Checkout',

  'checkout.total.promoApplied': 'Discount applied ',
  'checkout.total.promoAppliedWithPercentage':
    'Discount applied: {percentage}: ',

  'checkout.total.serviceFee': 'Service fee',
  'checkout.total.ProcessingFee': 'Processing fee',

  'checkout.cancel': 'Modify your purchase',
} as const;
